// Change here the implementation of any device api
// following the DeviceApi interface.
// WARNING: Application may break when changing the apis
// from the respective device package.

// eslint-disable-next-line strict
export const deviceApiOverrides = {};
